import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResumeQuoteIdCheckResponse, ResumeQuoteLeadCheckResponse } from 'models/resume-quote';
import { Observable } from 'rxjs';
import { AppConfigService } from 'sharedServices/app-config.service';
import { ApiBaseService } from 'sharedServices/api-base.service';

@Injectable({
    providedIn: 'root',
})
export class ResumeQuoteApiService extends ApiBaseService {
    constructor(
        public appConfig: AppConfigService,
        http: HttpClient,
    ) {
        super(appConfig, http);
    }

    initResumeLead = (
        encryptedLead: string,
        notifyComms: boolean,
    ): Observable<ResumeQuoteLeadCheckResponse> => {
        return this.http.get<ResumeQuoteLeadCheckResponse>(
            `${this.baseUrl()}/ResumeQuote/InitResumeLead?notifyComms=${notifyComms}`,
            {
                headers: this.headers()
                    .append('referenceNumber', encryptedLead)
                    .append('encryptedLead', 'true'),
                responseType: 'json',
            },
        );
    };

    checkIdValidity = (idNumber: string): Observable<ResumeQuoteIdCheckResponse> => {
        return this.http.get<ResumeQuoteIdCheckResponse>(
            `${this.baseUrl()}/ResumeQuote/CheckIdValidity`,
            {
                params: { idNumber },
                headers: this.headers(),
                responseType: 'json',
            },
        );
    };
}
